import { ApiTags } from '@nestjs/swagger';
import { Controller, Post, Body, Logger, Get, UseGuards,Req} from '@nestjs/common';
import {  InformationMessageError, NoRecordsFound, InternalServerError, ValidationMessageError,  errorHandler, ApplicationExceptionHandler} from '@gtpl/shared-utils/error-messages';
import {ExpensesSubCategoryDTO} from './dto/expenses-sub-category.dto';
import {ExpensesSubCategoryService} from './expenses-sub-category.service';
import { ExpensesSubCategoryResponse, AllExpensesSubCategoryResponse } from '@gtpl/shared-models/hrms';
import { ExpensesSubCategoryRequest } from './dto/expenses-sub-category.request';

@Controller('expenses-sub-category')
export class ExpensesSubCategoryController {


    constructor(
        private expensesSubCategoryService: ExpensesSubCategoryService,
    private readonly applicationExceptionHandler: ApplicationExceptionHandler

    ){}
    @Post('/createExpensesSubCategory')
    async createExpensesSubCategory(@Body() expensesSubCategoryDto:ExpensesSubCategoryDTO,isUpdate:boolean=false): Promise<ExpensesSubCategoryResponse> {
    try {
        return await this.expensesSubCategoryService.createExpensesSubCategory(expensesSubCategoryDto, false);
      } catch (error) {
        return this.applicationExceptionHandler.returnException(ExpensesSubCategoryResponse, error);
      }
    }
    @Post('/updateExpensesSubCategory')
  async updateExpensesSubCategory(@Body() expensesSubCategoryDto: ExpensesSubCategoryDTO,@Req() request:Request): Promise<ExpensesSubCategoryResponse> {
    try {
      console.log('update Expenses Sub Category');expensesSubCategoryDto
      console.log(request);
      return await this.expensesSubCategoryService.createExpensesSubCategory(expensesSubCategoryDto, true);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(ExpensesSubCategoryResponse, error);
    }
  }
  @Post('/getAllExpensesSubCategories')
  // @UseGuards(AuthGuard('jwt'))
  async getAllExpensesSubCategories(): Promise<AllExpensesSubCategoryResponse> {
    try {
      return await this.expensesSubCategoryService.getAllExpensesSubCategories();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(AllExpensesSubCategoryResponse, error);
    }
  }
  @Post('/activateOrDeactivateExpensesSubCategory')
  async activateOrDeactivateExpensesSubCategory(@Body() expensesSubCategoryReq: ExpensesSubCategoryRequest): Promise<ExpensesSubCategoryResponse> {
      try {
          return await this.expensesSubCategoryService.activateOrDeactivateExpensesSubCategory(expensesSubCategoryReq);
      } catch (err) {
          return this.applicationExceptionHandler.returnException(ExpensesSubCategoryResponse, err);
      }
  }
  @Post('/getAllActiveExpensesSubCategories')
  async getAllActiveExpensesSubCategories(@Req() request: Request): Promise<AllExpensesSubCategoryResponse> {
      try {
          return await this.expensesSubCategoryService.getAllActiveExpensesSubCategories();
      } catch (error) {
          return this.applicationExceptionHandler.returnException(AllExpensesSubCategoryResponse, error)
      }
  }
  @Post('/getExpensesSubCategoryById')
  async getExpensesSubCategoryById(@Body() expensesSubCategoryReq: ExpensesSubCategoryRequest): Promise<ExpensesSubCategoryResponse> {
      try {
          return await this.expensesSubCategoryService.getActiveExpensesSubCategoryById(expensesSubCategoryReq);
      } catch (err) {
          return this.applicationExceptionHandler.returnException(ExpensesSubCategoryResponse, err);
      }
  }

}
